import { Cross } from "lucide-react";
import { MARQUEE_ITEMS } from "@/data/content";

function MarqueeContent() {
  return (
    <div className="flex shrink-0 items-center">
      {MARQUEE_ITEMS.map((item, i) => (
        <span key={i} className="flex items-center">
          <span className="font-display text-sm sm:text-base tracking-[0.2em] uppercase text-[#C5A059] px-8 whitespace-nowrap">{item}</span>
          <Cross className="h-3.5 w-3.5 text-[#C5A059]/50 shrink-0" />
        </span>
      ))}
    </div>
  );
}

export default function Marquee() {
  return (
    <div data-testid="editorial-marquee" className="bg-[#4A0E17] border-y border-[#C5A059]/25 py-5 overflow-hidden">
      <div className="flex w-max animate-marquee">
        <MarqueeContent />
        <MarqueeContent />
      </div>
    </div>
  );
}
